const _range = (n, m) => [...Array(m - n).keys()].map(k => k + n);

// Create an array with elements spanning from the given start to the given end
export const range = (start, end) => {
  if (end) {
    return start > end ? _range(end, start) : _range(start, end);
  }
  return _range(0, start);
};

// Divide a given array into chunks of a desired size
export const chunkBy = (arr, size) => {
  const copy = [...arr];
  return size > 0 ? new Array(Math.ceil(copy.length / size)).fill().map(() => copy.splice(0, size)) : copy;
};

// Divide a given array into the desired number of given chunks
export const chunk = (arr, chunks) => chunkBy(arr, Math.ceil(arr.length / chunks));
